import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';

const Toolbar = styled.div`
  min-height: 2.5rem;
  ${(props) => {
    const spacing = props.spacing || '0.5rem';
    return css`
      ${mixin.horizontalFlow({ spacing })}
    `;
  }}
  justify-content: space-between;
`;

export default Toolbar;
